import { ProjectUserTypeEnum } from '@/graphql/generated/graphql';

export type NoteSectionType = {
  sectionName: string;
  sectionNotes: string[];
};

export type ManagersType = {
  id: string;
  title: string;
  userType: ProjectUserTypeEnum;
  companyResourceId?: string;
  employmentId?: string;
  userId?: string;
};

export interface Activity {
  id: string;
  title: string;
  description: string;
  startTime: string;
  endTime: string;
  supervisorId: string | null;
  colorCode: string;
}

export interface Settings {
  name: string;
  value: string;
}

export const DEFAULT_SECTION: NoteSectionType = {
  sectionName: 'Untitled Section',
  sectionNotes: [],
};

export interface ProjectActivitiesProps {
  activities: Activity[];
  setActivities: React.Dispatch<React.SetStateAction<Activity[]>>;
}
